export default {
  slug: "youtrack",
  code: "YT",
  label: "YouTrack",
  krakenDir: "YouTrack",
  logoFamily: "youtrack",
};
